var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import Button from "antd/es/button";
import "antd/es/button/style/index.js";
let MenubarHearListenPopover = class MenubarHearListenPopover extends React.PureComponent {
    render() {
        const { app } = this.props;
        const menubarHear = app.menubar.menubarHear;
        return (React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                minWidth: 500,
                minHeight: 100,
                paddingLeft: 15
            }, onMouseEnter: action(() => (menubarHear.isHearPopoverHovering = true)), onMouseLeave: action(() => (menubarHear.isHearPopoverHovering = false)) },
            React.createElement("h4", null, "Zuletzt erkannt:"),
            React.createElement(Button, { size: "large" }, app.aural && app.aural.auralSentence.bestGuessSentence)));
    }
};
MenubarHearListenPopover = __decorate([
    observer
], MenubarHearListenPopover);
export { MenubarHearListenPopover };
//  <Button onClick={() => (app.hear.aural.isRecognitionEnabledByUser = true)}>Spracheingabe deaktivieren</Button>
let MenubarHearRunningTitle = class MenubarHearRunningTitle extends React.PureComponent {
    render() {
        const { app } = this.props;
        const menubarHear = app.menubar.menubarHear;
        return 'Du kannst jetzt sprechen!';
    }
};
MenubarHearRunningTitle = __decorate([
    observer
], MenubarHearRunningTitle);
export { MenubarHearRunningTitle };
